// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-viewer-info {
  display: flex;
  position: relative;
  align-items: center;
  margin: 0;
  border: solid 1px #83b6df;
  border-radius: 3px;
  background-color: white;
  padding: 0;
  height: auto;
}
.map-viewer-info .coordinates {
  display: flex;
  justify-content: space-around;
  z-index: 1;
  padding: 0 10px 0 10px;
  color: gray;
  font-size: 0.8em;
  white-space: nowrap;
}
.map-viewer-info .coordinates.type-mouse.round-0 {
  width: 135px;
}
.map-viewer-info .coordinates.type-extent.round-0 {
  width: 230px;
}
.map-viewer-info .coordinates.type-mouse.round-2 {
  width: 100px;
}
.map-viewer-info .coordinates.type-extent.round-2 {
  width: 160px;
}
.map-viewer-info .switch {
  vertical-align: -3px;
  border-radius: 2px;
  padding: 0.4px 0;
  width: 28px;
  height: 28px;
  font-size: 15px;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/webmap/nodepkg/map-viewer-info/MapViewerInfo.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;AACJ;AAVA;EAYQ,aAAA;EACA,6BAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AACR;AACQ;EACI,YAAA;AACZ;AAEQ;EACI,YAAA;AAAZ;AAGQ;EACI,YAAA;AADZ;AAIQ;EACI,YAAA;AAFZ;AA/BA;EAsCQ,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAJR","sourcesContent":[".map-viewer-info {\n    display: flex;\n    position: relative;\n    align-items: center;\n    margin: 0;\n    border: solid 1px #83b6df;\n    border-radius: 3px;\n    background-color: white;\n    padding: 0;\n    height: auto;\n\n    .coordinates {\n        display: flex;\n        justify-content: space-around;\n        z-index: 1;\n        padding: 0 10px 0 10px;\n        color: gray;\n        font-size: 0.8em;\n        white-space: nowrap;\n\n        &.type-mouse.round-0 {\n            width: 135px;\n        }\n\n        &.type-extent.round-0 {\n            width: 230px;\n        }\n\n        &.type-mouse.round-2 {\n            width: 100px;\n        }\n\n        &.type-extent.round-2 {\n            width: 160px;\n        }\n    }\n\n    .switch {\n        vertical-align: -3px;\n        border-radius: 2px;\n        padding: 0.4px 0;\n        width: 28px;\n        height: 28px;\n        font-size: 15px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
